import axios from "axios";
import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";

// Smart detection: Use local backend if on localhost, otherwise relative path for production (best for CORS)
const getBaseURL = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // If we are on the production domain or Firebase hosting domain, use relative paths
    // This leverages Firebase Hosting rewrites to the Cloud Run backend.
    if (hostname === 'mokiplaner.com' ||
      hostname === 'www.mokiplaner.com' ||
      hostname.endsWith('.web.app') ||
      hostname.endsWith('.firebaseapp.com')) {
      return "";
    }

    // Local development defaults
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return "http://localhost:8000";
    }
  }

  // Fallback if no hostname matches (should not happen on web)
  return "";
};

const BACKEND_URL = getBaseURL();
const API = (BACKEND_URL ? (BACKEND_URL.endsWith('/') ? BACKEND_URL.slice(0, -1) : BACKEND_URL) : "") + "/api";

// Expose to global window object for components that use them without importing
if (typeof window !== 'undefined') {
  window.BACKEND_URL = BACKEND_URL;
  window.API = API;
  window.format = format;
  window.parseISO = parseISO;
  window.de = de;
}

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { "Authorization": `Bearer ${token}` } : {};
};

// Check if we have a JWT token (use token-based auth instead of cookies)
const hasToken = () => !!localStorage.getItem("auth_token");

// Authenticated GET request
export const authGet = async (endpoint) => {
  const headers = getAuthHeaders();
  return axios.get(`${API}${endpoint}`, {
    withCredentials: !hasToken(), // Only use cookies if no token
    headers
  });
};

// Authenticated POST request
export const authPost = async (endpoint, data) => {
  const headers = getAuthHeaders();
  return axios.post(`${API}${endpoint}`, data, {
    withCredentials: !hasToken(),
    headers
  });
};

// Authenticated PUT request
export const authPut = async (endpoint, data) => {
  const headers = getAuthHeaders();
  return axios.put(`${API}${endpoint}`, data, {
    withCredentials: !hasToken(),
    headers
  });
};

// Authenticated DELETE request
export const authDelete = async (endpoint) => {
  const headers = getAuthHeaders();
  return axios.delete(`${API}${endpoint}`, {
    withCredentials: !hasToken(),
    headers
  });
};

export { BACKEND_URL, API, getAuthHeaders, hasToken };
export default API;
